import { useEffect, useState } from 'react';

import { platformListPlatformVersions } from '@cloudquery/api-platform';
import { useLocalStorage } from 'shared/base';

import { PlatformPermissions } from '@/constants/platformPermissions';
import { useHasTeamsPermissions } from '@/hooks/useHasTeamsPermissions';

import { PlatformVersionUpgradeAlert } from './platformVersionUpgradeAlert';
import { PlatformVersionUpgradeDialog, State as DialogState } from './platformVersionUpgradeDialog';

const LATEST_USED_PLATFORM_VERSION_LOCAL_STORAGE_KEY = 'platform-latest-used-version';

export const PlatformVersionUpgrade = () => {
  const { setValue: setLatestUsedPlatformVersion, value: latestUsedPlatformVersion } =
    useLocalStorage(
      LATEST_USED_PLATFORM_VERSION_LOCAL_STORAGE_KEY,
      process.env.NEXT_PUBLIC_CQ_PLATFORM_VERSION,
    );

  const [showBanner, setShowBanner] = useState(false);
  const [dialogState, setDialogState] = useState<DialogState>({ type: 'closed' });

  useEffect(() => {
    if (
      typeof process.env.NEXT_PUBLIC_CQ_PLATFORM_VERSION === 'string' &&
      latestUsedPlatformVersion !== process.env.NEXT_PUBLIC_CQ_PLATFORM_VERSION
    ) {
      setShowBanner(true);
      setLatestUsedPlatformVersion(process.env.NEXT_PUBLIC_CQ_PLATFORM_VERSION);
    }
  }, [latestUsedPlatformVersion, setLatestUsedPlatformVersion]);

  const hasPermissionsToSeePlatformVersionUpgradeInfo = useHasTeamsPermissions([
    PlatformPermissions.ADMIN_READ,
  ]);

  return hasPermissionsToSeePlatformVersionUpgradeInfo ? (
    <>
      <PlatformVersionUpgradeAlert
        onClose={() => setShowBanner(false)}
        onViewUpdatesClick={() => {
          platformListPlatformVersions({ page: 1, per_page: 2 }).then((res) => {
            if (res.data.items.length < 2) {
              setShowBanner(false);

              return;
            }

            setDialogState({
              newVersion: res.data.items[0].name,
              newVersionReleaseDate: new Date(res.data.items[1].created_at),
              oldVersion: res.data.items[1].name,
              type: 'open',
            });

            setShowBanner(false);
          });
        }}
        visible={showBanner}
      />
      <PlatformVersionUpgradeDialog
        onClose={() => setDialogState({ type: 'closed' })}
        state={dialogState}
      />
    </>
  ) : null;
};
